import {
  SEND_MFA,
  SET_USERNAME,
  SEND_MFA_SUCCESS,
  SEND_MFA_FAILURE,
  VERIFY_MFA,
  VERIFY_MFA_SUCCESS,
  VERIFY_MFA_FAILURE,
  LOGIN_RESET
} from './actions';
import {
  APP_LOGOUT
} from '../../redux-root/actions';

const initialState = {
  sendData: null,
  sendFail: false,
  mfaData: null,
  verifyFail: false,
  resend: false,
  reset: false
}

export function loginReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case SEND_MFA:
      return {
        ...state,
        sendData: null,
        sendFail: false,
        resend: false,
        reset: false
      }

    case SEND_MFA_SUCCESS:
      return {
        ...state,
        sendData: data
      }

    case SEND_MFA_FAILURE:
      return {
        ...state,
        sendFail: true
      }

    case VERIFY_MFA:
      return {
        ...state,
        mfaData: null,
        verifyFail: false
      }

    case VERIFY_MFA_SUCCESS:
      return {
        ...state,
        mfaData: data,
        sendData: null,
      }

    case VERIFY_MFA_FAILURE:
      return {
        ...state,
        verifyFail: true,
        resend: action.resend ? action.resend : false
      }

    case LOGIN_RESET:
      return {
        sendData: null,
        sendFail: false,
        mfaData: null,
        verifyFail: false,
        resend: false,
        reset: true
      }

    case APP_LOGOUT:
      let newReset = false;

      if (action.expired) {
        newReset = action.expired;
      }

      return {
        ...state,
        reset: newReset
      }

    default:
      return state;
  }
}
